module.exports = __webpack_public_path__ + "static/logo-8b6a8a0daa1a4d4e99f74633fdef638a.svg";